var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import clsx from 'clsx';
import { isNil, useClasses, useLayoutProps, useProps } from '@hawkins/helpers';
import { useNotificationBadgeStyles } from './notificationBadge.styles';
var displayName = 'InlineNotificationBadge';
/**
 * An inline notification badge component used under the hood by <NotificationBadge>.
 */
export var InlineNotificationBadge = forwardRef(function (props, ref) {
    var _a;
    // Props
    var _b = useProps(displayName, props), classesProp = _b.classes, className = _b.className, _c = _b.compact, compact = _c === void 0 ? false : _c, _d = _b.component, Component = _d === void 0 ? 'span' : _d, count = _b.count, _e = _b.invisible, invisible = _e === void 0 ? false : _e, layout = _b.layout, _f = _b.max, max = _f === void 0 ? 99 : _f, styleProp = _b.style, variant = _b.variant, restProps = __rest(_b, ["classes", "className", "compact", "component", "count", "invisible", "layout", "max", "style", "variant"]);
    var badgeContent = !compact && !isNil(count) ? (count > max ? "".concat(max, "+") : String(count)) : '';
    // Styles
    var baseClasses = useNotificationBadgeStyles();
    var classes = useClasses(displayName, baseClasses, classesProp);
    var style = useLayoutProps({ layout: layout, style: styleProp });
    var rootClassName = clsx(classes.HAWKINS_BASE, className, classes.root, (_a = {},
        _a[classes.compact] = compact,
        _a[classes.dot] = variant === 'dot' || badgeContent === '',
        _a[classes.invisible] = invisible,
        _a));
    return (_jsx(Component, __assign({ className: rootClassName, ref: ref, style: style }, restProps, { children: badgeContent })));
});
InlineNotificationBadge.displayName = displayName;
